// 当前页面基本url 地址是
// http://localhost:8080/wood/image/create

import { indexAxios } from "@/axios/index";

//  获取微观数据和宏观数据的接口 plant-index/listByType
export const getMicroAndMacroData = async (type) => {
  return await indexAxios({
    url: "plant-index/listByType",
    method: "post",
    params: { type },
  });
};
//  获取植物分类详情 wood-appraisal/getById/2003632771973246977
export const getWoodAppraisalDetail = async (id) => {
  return await indexAxios({
    url: `wood-appraisal/getById/${id}`,
    method: "get",
  });
};
